'use strict';

const angular = require('angular');

import { ISeasonUtilsService, IPickupUtilsService, IMembership, ISeason, IPrice, IPickupOption } from '../interfaces';

class Extra {
    extraRef: any;
    selected: boolean;
    quantity: number;
    totalPrice: number;
    
    constructor(extraRef, selected, quantity, totalPrice) {
        this.extraRef = extraRef;
        this.selected = selected;
        this.quantity = quantity;
        this.totalPrice = totalPrice;
    }
}

export class membershipBasketsComponent{
    $http: ng.IHttpService;
    SeasonUtils: ISeasonUtilsService;
    PickupUtils: IPickupUtilsService;
    TranslationService: any;
    
    // activeSeason: ISeason;
    // registrationSeason: ISeason;
    season: ISeason;
    membership: IMembership;
    basket: any;

    extraEmail: String;
    extraEmailSubmitted = false;

    submitted = false;
    editMode = false;
    isTotalPriceAvailable = true;

    extrasSelected: Extra[] = [];
    extraTotal: number = 0;

    pickupSelected: any;
    priceSelected: any;

    memberTypeSelected: string = '';
    memberReferenceName: string = '';

    /*ngInjector*/
    constructor($http, SeasonUtils: ISeasonUtilsService, PickupUtils, TranslationService) {
        this.$http = $http;
        this.SeasonUtils = SeasonUtils;
        this.PickupUtils = PickupUtils;
        this.TranslationService = TranslationService;
    }

    $onInit() {
        let resolve = (this as any).resolve;
        this.extraEmail = '';
        this.priceSelected = null;
        this.pickupSelected = null;
        
        // Get the season parameter
        if (_.has(resolve, 'registrationSeason') && resolve.registrationSeason) {
            this.season = _.cloneDeep(resolve.registrationSeason);
        }
        
        // Get the membership parameter
        if (_.has(resolve, 'membership') && resolve.membership !== null) {
            this.membership = _.cloneDeep(resolve.membership);
        } else {
            this.cancel();
        }

        // Get the basket parameter to know if it is creation or edit mode
        if (_.has(resolve, 'basket') && resolve.basket !== null) {
            // Edition
            this.editMode = true;
            this.basket = _.cloneDeep(resolve.basket);
            this.basket.numPaymentsExpected = this.basket.numPaymentsExpected.toString();

            this.season = this.basket.season;
            this.priceSelected  = this.basket.newPrice;
            this.memberTypeSelected = this.basket.memberType;
            this.memberReferenceName = this.basket.memberReferenceName;
            
            // Finding the right pickup option
            this.season.activePickupOptions.some(pickupOption => {
                if (pickupOption && pickupOption._id === this.basket.defaultPickupOption._id) {
                    this.pickupSelected = pickupOption;
                    return true;
                }
            });

        } else { 
            // Creation
            this.basket = {};
            this.basket.numPaymentsExpected = "1";
            this.basket.extraEmails = [];
            this.updateDeadlines(this.basket.numPaymentsExpected);

            if (!this.season) {
              this.cancel();
            }
        }

        // FInd total price calculation if it is available
        let currentTime = (new Date()).getTime();
        let startSeasonTime = (new Date(this.season.firstEventDate)).getTime();
        let fourWeeksTime = 24*60*60*1000*7*4;
        
        //TODO: To activate to next season
        //this.isTotalPriceAvailable = currentTime - startSeasonTime <= fourWeeksTime;

        // Reset Extras
        this.extrasSelected = [];
        this.season.availableExtras.forEach(availableExtra => {
          if (this.editMode) {
            let extraQuantity = this.basket.extras.find(e => e.extra._id === availableExtra._id);
            if (extraQuantity) {
              this.extrasSelected.push( new Extra(availableExtra, true, extraQuantity.quantity, extraQuantity.totalPrice));
            } else {
              this.extrasSelected.push( new Extra(availableExtra, false, 0, 0));  
            }

          } else {
            this.extrasSelected.push( new Extra(availableExtra, false, 0, 0));
          }
        });

        // Reset submit form
        this.submitted = false;
        this.extraEmailSubmitted = false;
    }
    
    /**
     * Save temporary of the pickup option selected
     * @param pickupOption 
     */
    selectPickupOption(pickupOption: any) {
      this.basket.defaultPickupOption = pickupOption;
    }

    getExtraBases(extra) {
      return extra.extraRef.extraBases[this.TranslationService.getCurrentLanguage()=='en' ? 0:1];
    }

    getPriceBases(price) {
      return price.priceBases[this.TranslationService.getCurrentLanguage()=='en' ? 0:1];
    }

    getPriceIntroduction() {
      if ( this.TranslationService.getCurrentLanguage() === 'en' ) {
        return this.season.priceIntroductionEn;
      } else {
        return this.season.priceIntroductionFr;
      }
    }

    getExtraIntroduction() {
      if ( this.TranslationService.getCurrentLanguage() === 'en' ) {
        return this.season.extraIntroductionEn;
      } else {
        return this.season.extraIntroductionFr;
      }
    }

    getExtraLinkText() {
      if ( this.TranslationService.getCurrentLanguage() === 'en' ) {
        return this.season.extraLinkTextEn;
      } else {
        return this.season.extraLinkTextFr;
      }
    }

    getExtraLink() {
      if ( this.TranslationService.getCurrentLanguage() === 'en' ) {
        return this.season.extraLinkEn ? this.season.extraLinkEn : '';
      } else {
        return this.season.extraLinkFr ? this.season.extraLinkFr : '';
      }
    }

    plusExtra(extra) {
      extra.selected = true;
      extra.quantity += 1;
      extra.totalPrice = Number(extra.quantity * extra.extraRef.price).toFixed(2);
    }

    minusExtra(extra) {
      if (extra.quantity == 0) {
        extra.selected = false;
      }
      extra.quantity -= 1;
      extra.totalPrice = Number(extra.quantity * extra.extraRef.price).toFixed(2);
    }

    selectPrice(price) {
      this.priceSelected = price;
    }

    isExtraSelected() {
      return this.extrasSelected.length>0 && this.extrasSelected.filter( extraSelected => extraSelected.selected && extraSelected.quantity>0 ).length > 0;
    }

    isExtraDisabled(extra) {
      let extraDeadlineTime = new Date(extra.extraRef.deadline).getTime();
      let currentTime = (new Date()).getTime();
      return currentTime > extraDeadlineTime;
    }

    updateDeadlines(value) {
      let deadlines: Date[] = this.SeasonUtils.getDeadlinesForNumberOfPayments(this.season, this.basket.numPaymentsExpected);
      
      this.basket.payments = [];
      for (let deadline of deadlines) {
        this.basket.payments.push({date: deadline, amount: 0});
      }
    }

    getBasketPrice() {
      let price = 0;

      if (this.basket.price) {
        price = this.basket.price;
      } else if (this.priceSelected) {
        price = this.priceSelected.price;
      }
      return Number(price).toFixed(2);
    }

    getExtraTotal() {
      let total = 0;
      for(let extra of this.extrasSelected) {
        if (extra.selected && extra.quantity>0) {
          total = total + Number(extra.totalPrice);
        }
      }
      return  Number(total).toFixed(2);
    }

    getTotal() {
      let basketPrice = this.getBasketPrice();
      let extrasPrice = this.getExtraTotal();

      return (Number(basketPrice) + Number(extrasPrice)).toFixed(2);
    }

    isTwoPaymentsAllow() {
      let weekTime = 7*24*60*60*1000;
      let currentTime = (new Date()).getTime();
      let thirdDeadlineTime = ( new Date(this.season.paymentDeadlines[2]) ).getTime();
      return currentTime < thirdDeadlineTime - weekTime;
    }

    isFourPaymentsAllow() {
        let weekTime = 7*24*60*60*1000;
        let currentTime = (new Date()).getTime();
        let secondDeadlineTime = ( new Date(this.season.paymentDeadlines[1]) ).getTime();
        return currentTime < secondDeadlineTime - weekTime;
      }

    /**
     * Save basket for the current membership.
     * Extras has to be transformed
     * @param basket 
     */
    createBasket(form) {
        this.submitted = true;
        this.extraEmailSubmitted = false;

        if(form.$valid) {
            this.$http.post("/api/baskets/", {
                membership: this.membership._id, 
                season: this.season,
                defaultPickupOption: this.pickupSelected, 
                extras: this.extrasSelected
                    .filter(extraSelected => extraSelected.selected && extraSelected.quantity>0)
                    .map(extraSelected => ({
                      extra:extraSelected.extraRef, 
                      quantity: extraSelected.quantity, 
                      totalPrice: this.isTotalPriceAvailable ? extraSelected.totalPrice : null
                    })),
                //price: this.isTotalPriceAvailable ? this.basket.price : null,
                price: null,
                newPrice: this.priceSelected,
                numPaymentsExpected: this.basket.numPaymentsExpected,
                payments: this.basket.payments,
                extraEmails: this.basket.extraEmails,
                creationDate: new Date(),
                memberType: this.memberTypeSelected,
                memberReferenceName: this.memberTypeSelected === 'new' ? this.memberReferenceName.substring(0, 40) : ''
            })
            .then(res => {
                this.basket = res.data;
                this.ok();
            });
        }
    }

    saveBasket(form) {
      this.submitted = true;
      this.extraEmailSubmitted = false;

      if (form.$valid) {
        let candidate = _.cloneDeep(this.basket);
        candidate.memberType = this.memberTypeSelected;
        candidate.memberReferenceName = this.memberTypeSelected === 'new' ? this.memberReferenceName.substring(0, 40) : '';
        candidate.newPrice = this.priceSelected;
        candidate.price = null;
        candidate.defaultPickupOption = this.pickupSelected;
        candidate.extras = this.extrasSelected
          .filter(extraSelected => extraSelected.selected && extraSelected.quantity>0)
          .map(extraSelected => ({
            extra:extraSelected.extraRef, 
            quantity: extraSelected.quantity, 
            totalPrice: this.isTotalPriceAvailable ? extraSelected.totalPrice : null
          }));

        this.$http.put("/api/baskets/"+candidate._id, candidate)
        .then(res => {
          this.basket = res.data;
          this.ok();
        });;
      }
    }

    addExtraEmail(extraEmailInput) {
      if (this.extraEmail === '' || this.basket.extraEmails.indexOf(this.extraEmail) > -1) {
        return false;
      }

      this.extraEmailSubmitted = true;

      if ( this.basket.extraEmails.length < 3 && extraEmailInput.$valid ) {
        this.basket.extraEmails.push(this.extraEmail);
        this.extraEmail = '';
        this.extraEmailSubmitted = false;
      }
    }

    removeExtraEmail(email) {
      var index = this.basket.extraEmails.indexOf(email);
      this.basket.extraEmails.splice( index, 1 );
    }

    ok() {
      (this as any).close({$value: this.basket});
    };

    cancel() {
      (this as any).dismiss({$value: 'cancel'});
    };

}

export default angular.module('terrappApp.membership')
    .component('membershipBaskets', {
        template: require('./membershipBaskets.html'),
        controller: membershipBasketsComponent,
        controllerAs: '$ctrl',
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
  }).name;


// WEBPACK FOOTER //
// ./client/app/membership/membershipBaskets.component.ts